var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 30,
    viewBox: "0 0 19 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.9463V28H13C13.5522 28 14 28.4478 14 29C14 29.5522 13.5522 30 13 30H9.5H6C5.44775 30 5 29.5522 5 29C5 28.4478 5.44775 28 6 28H8.5V25.9463C3.73016 25.4448 0 21.4005 0 16.5C0 15.9478 0.447754 15.5 1 15.5C1.55225 15.5 2 15.9478 2 16.5C2 20.6355 5.3645 24 9.5 24C13.6355 24 17 20.6355 17 16.5C17 15.9478 17.4478 15.5 18 15.5C18.5522 15.5 19 15.9478 19 16.5C19 21.4005 15.2698 25.4448 10.5 25.9463ZM9.5 22.5C13.0842 22.5 16 19.5842 16 16V6.5C16 2.91577 13.0842 0 9.5 0C5.91577 0 3 2.91577 3 6.5V16C3 19.5842 5.91577 22.5 9.5 22.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/micIcon.8134126a05685efd384e3903aef18883.svg";
export { ForwardRef as ReactComponent };